import React from 'react';
import {links} from "../../constants/links";

function NavigationDots({active}) {

    return (
        <div className="app__navigation">
            {
                links.map((item, index) => (
                    <a
                        className="app__navigation-dot"
                        href={`#${item}`}
                        key={item}
                        style={active === item ? {backgroundColor: "#313BAC"} : {}}
                    />
                ))
            }
        </div>
    );
}

export default NavigationDots;